import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import { ListItemButton, SxProps, Theme, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

export interface IDocumentHyperlinkProps {
  link?: string;
  icon?: React.ReactElement | null;
  iconOrientation?: 'left' | 'right';
  target?: React.HTMLAttributeAnchorTarget;
  dataAutomation?: string;
  title: string;
  styles?: SxProps<Theme>;
  onClick?: () => void;
}

export const DocumentHyperlink: React.FC<IDocumentHyperlinkProps> = ({
  link,
  icon = <PictureAsPdfRoundedIcon />,
  target = "_blank",
  iconOrientation = 'left',
  dataAutomation,
  title,
  styles,
  onClick
}) => {
  const theme = useTheme();
  return (
    <Typography
      component='div'
      variant='document-hyperlink'
      sx={{
        '& > .MuiSvgIcon-root': {
          ml: iconOrientation === 'right' ? theme.spacing(0.5) : null,
          mr: iconOrientation === 'left' ? theme.spacing(0.5) : null,
        },
        ...styles
      }}
    >
      {iconOrientation === 'left' && icon}
      {
        onClick ?
          <ListItemButton onClick={onClick} data-automation={dataAutomation}>
            {title}
          </ListItemButton>
          :
          <Typography
            component={Link}
            to={link || ''}
            target={target}
            data-automation={dataAutomation || 'DocumentHyperlink'}
          >
            {title}
          </Typography>
      }
      {iconOrientation === 'right' && icon}
    </Typography>
  );
}